window.addEventListener('DOMContentLoaded', function() {
  // 外部リンクは別タブ
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  // Floor201 LPだけで計測
  if (!location.pathname.startsWith("/pages/floor201-01")) return;

  function isLineLink(url) {
    if (!url) return false;
    return (
      url.includes("lin.ee/") ||
      url.includes("line.me/") ||
      url.includes("page.line.me/") ||
      url.startsWith("line://")
    );
  }

  // LINEリンククリックをdataLayerへ
  document.addEventListener("click", function (e) {
    const a = e.target.closest && e.target.closest("a");
    if (!a) return;

    const href = a.getAttribute("href") || "";
    if (!isLineLink(href)) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "line_click", line_url: href });
  }, true);
});